export const RECORDING_PENDING_MS = 6 * 60 * 1000;
export const RECORDING_RETRY_MS = 12 * 1000;

export const formatCallLogDateTime = (callDate) => {
  if (!callDate) return "-";
  const parsed = new Date(callDate);
  if (Number.isNaN(parsed.getTime())) return String(callDate);
  return parsed.toLocaleString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

const parseRecordDate = (record) => {
  if (!record) return null;
  const raw = record.tarih || record.call_date || record.call_tarih;
  if (!raw) return null;
  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) return parsed;
  const match = String(raw).match(/(\d{2})\.(\d{2})\.(\d{4})[,\s]+(\d{2}):(\d{2})(?::(\d{2}))?/);
  if (!match) return null;
  return new Date(+match[3], +match[2] - 1, +match[1], +match[4], +match[5], +(match[6] || 0));
};

const getRecordAgeMs = (record) => {
  const parsed = parseRecordDate(record);
  if (!parsed) return null;
  return Date.now() - parsed.getTime();
};

export const isRecordWithinRecordingPendingWindow = (record) => {
  const age = getRecordAgeMs(record);
  return age !== null && age >= 0 && age < RECORDING_PENDING_MS;
};

export const shouldExpectRecording = (record) => Number(record?.konusma_suresi || record?.duration || 0) > 0;

export const getRecordingPendingRemainingMs = (record) => {
  const age = getRecordAgeMs(record);
  if (age === null) return 0;
  return Math.max(0, RECORDING_PENDING_MS - age);
};

export const formatPendingRemaining = (ms) => {
  const totalSec = Math.ceil(ms / 1000);
  const mins = Math.floor(totalSec / 60);
  const secs = totalSec % 60;
  if (mins <= 0) return `${secs} sn`;
  return secs > 0 ? `${mins} dk ${secs} sn` : `${mins} dk`;
};
